import Auth from "@aws-amplify/auth";

export interface IdToken {
  userId: string;
  groups: string[];
  [id: string]: any; // NOTE: this is the default definition for aws' id token type
}

export interface IdTokens {
  idToken: IdToken;
  rawIdToken: string;
}

export async function getIdToken(): Promise<IdTokens> {
  const session = await Auth.currentSession();
  const token = await session.getIdToken();
  const { payload } = token;
  const groups = payload["cognito:groups"] || [];

  const idToken = {
    ...payload,
    userId: payload.sub,
    groups
  };
  return { rawIdToken: token.getJwtToken(), idToken };
}

export async function getUserGroups(): Promise<string[]> {
  const groups = [];
  try {
    const { idToken } = await getIdToken();
    groups.push(...idToken.groups);
  } catch (err) {
    // swallow error, we'll just assume there is no
    // user or no groups for the current user
  }

  return groups;
}
